import React from 'react'
import PropTypes from 'prop-types';
import {
    StyledTitle,
    StyledSubtitle,
    StyledHighlight,
    StyledParagraph
} from 'styled/UI/StyledText';
import colors from 'theme/colors';

function Text({
    // layout props
    marginTop,
    marginRight,
    marginBottom,
    marginLeft,
    paddingTop,
    paddingRight,
    paddingBottom,
    paddingLeft,
    // action props
    name,
    type,
    decoration,
    color,
    ellipsisAt,
    children,
    textAlign, 
    style,
    dangerouslySetInnerHTML = {}
}) {
    const renderText = () => {
        if (name === 'hero' || name === 'title') {
            return (
                <StyledTitle
                    name={name}
                    type={type}
                    color={color}
                    textAlign={textAlign}
                    marginTop={marginTop}
                    marginRight={marginRight}
                    marginBottom={marginBottom}
                    marginLeft={marginLeft}
                    paddingTop={paddingTop}
                    paddingRight={paddingRight}
                    paddingBottom={paddingBottom}
                    paddingLeft={paddingLeft} 
                    ellipsisAt={ellipsisAt}
                    style={style}
                >
                    {children}
                </StyledTitle>
            );
        }

        if (name === 'subtitle') {
            return (
                <StyledSubtitle
                    name={name}
                    type={type}
                    color={color}
                    textAlign={textAlign}
                    marginTop={marginTop}
                    marginRight={marginRight}
                    marginBottom={marginBottom}
                    marginLeft={marginLeft}
                    paddingTop={paddingTop}
                    paddingRight={paddingRight}
                    paddingBottom={paddingBottom}
                    paddingLeft={paddingLeft}            
                    ellipsisAt={ellipsisAt}
                    style={style}
                >
                    {children}
                </StyledSubtitle>
            );
        }

        if (name === 'highlight') {
            return (
                <StyledHighlight
                    name={name}
                    type={type}
                    color={color}
                    textAlign={textAlign}
                    marginTop={marginTop}
                    marginRight={marginRight}
                    marginBottom={marginBottom}
                    marginLeft={marginLeft}
                    paddingTop={paddingTop}
                    paddingRight={paddingRight}
                    paddingBottom={paddingBottom}
                    paddingLeft={paddingLeft}
                    ellipsisAt={ellipsisAt}
                    style={style}
                >
                    {children}
                </StyledHighlight>
            );
        }

        return (
            <StyledParagraph
                name={name}
                type={type}
                color={color}
                textAlign={textAlign}
                decoration={decoration}
                marginTop={marginTop}
                marginRight={marginRight}
                marginBottom={marginBottom}
                marginLeft={marginLeft}
                paddingTop={paddingTop}
                paddingRight={paddingRight}
                paddingBottom={paddingBottom}
                paddingLeft={paddingLeft}
                ellipsisAt={ellipsisAt}
                style={style}
            >
                {children}
            </StyledParagraph>
        );
    };

    return renderText();
}

Text.propTypes = {
    color: PropTypes.string,

    type: PropTypes.oneOf(['normal', 'bold', 'italic']),

    name: PropTypes.oneOf([
        'hero',
        'title',
        'subtitle',
        'highlight',
        'default',
        'small',
        'mini'
    ])
};

Text.defaultProps = {
    color: colors.night,
    type: 'normal',
    name: 'default',
    decoration: 'none'
};

export default Text;